import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Flex, FlexBehavior, FlexAlignItems, magma } from 'react-magma-dom';
import { OpenInNewIcon } from 'react-magma-icons';
import { LeadParagraph } from '../../components/LeadParagraph';
import { StorybookIcon } from '../../images/icons/storybook-icon';
export const MagmaChartsSiteLink = () => <Link to="https://storybook-preview-dev--upbeat-sinoussi-f675aa.netlify.app/?path=/story/carbonchart" target="_blank" mdxType="Link">
    <Flex behavior={FlexBehavior.container} alignItems={FlexAlignItems.center} style={{
    backgroundColor: magma.colors.neutral200,
    width: 'fit-content',
    gap: magma.spaceScale.spacing03,
    padding: `${magma.spaceScale.spacing04} ${magma.spaceScale.spacing05}`,
    borderRadius: magma.spaceScale.spacing03
  }} mdxType="Flex">
      <StorybookIcon mdxType="StorybookIcon" />
      <span>Magma Charts demo site</span>
      <OpenInNewIcon size={magma.iconSizes.small} mdxType="OpenInNewIcon" />
    </Flex>
  </Link>;
export const _frontmatter = {
  "title": "Getting Started",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const Alert = makeShortcode("Alert");
const Link = makeShortcode("Link");
const layoutProps = {
  MagmaChartsSiteLink,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageContent componentName="getting_started" type="data_visualization" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Magma charts enable you to convey precise and compelling narratives around
  data through visually appealing and accessible visualizations. 
      </LeadParagraph>
      <p>{`Magma Charts is based on `}<a parentName="p" {...{
          "href": "https://charts.carbondesignsystem.com/introduction"
        }}>{`Carbon Charts from IBM`}</a>{`.`}</p>
      <p>{`Get started below with implementation instructions for developers. You can also learn more about the `}<a parentName="p" {...{
          "href": "../chart-types"
        }}>{`chart types`}</a>{` we provide, as well as `}<a parentName="p" {...{
          "href": "../chart-demos"
        }}>{`view examples`}</a>{`.`}</p>
      <MagmaChartsSiteLink mdxType="MagmaChartsSiteLink" />
      <h2>{`Installation`}</h2>
      <Alert variant="warning" mdxType="Alert">
  <strong>Important!</strong> CarbonChart is imported from{' '}
  <inlineCode>@react-magma/charts</inlineCode> which must be installed as a peer
  dependency.
  <br />
  <br />
  In addition, you must manually import the styles:
  <br />
  <inlineCode>import '@react-magma/charts/dist/charts.css';</inlineCode>
      </Alert>
      <h3>{`Setup Requirements`}</h3>
      <p>{`Your project needs to be running `}<strong parentName="p">{`React v17`}</strong></p>
      <h3>{`Install the Charts Library`}</h3>
      <p>{`Install the React Magma Charts library with `}<inlineCode parentName="p">{`npm`}</inlineCode>{`.`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save react-magma@charts
`}</code></pre>
      <p>{`Install peer dependencies`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh",
          "metastring": "title noRender noCodeSandbox",
          "title": true,
          "noRender": true,
          "noCodeSandbox": true
        }}>{`npm install --save \\
    "@emotion/react@^11.13.0" \\
    "@emotion/styled@^11.13.0" \\
    "react@^17.0.2" \\
    "react-dom@^17.0.2" \\
    "react-magma-dom@^4.7.0-next.1" \\
    "react-magma-icons@^3.0.0" \\
    "@react-magma/charts@^9.0.0"
`}</code></pre>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      